import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import { TkGetCodeList } from "../../utils/TkGetCode";

export enum AddPaymentReason {
  "計算基礎額の増加（「俸給表の額」の訂正）" = "1",
  "計算基礎額の増加（「俸給の調整額」の訂正）" = "2",
  "被共済職員期間の増加（従業状況の訂正）" = "3",
  "被共済職員期間の増加（合算漏れの訂正）" = "4",
  "支給該当者への変更（従業状況の訂正）" = "5",
  "支給該当者への変更（合算漏れの訂正）" = "6",
  "計算基礎額の減少" = "7",
  "被共済職員期間の減少" = "8",
  "支給非該当者への変更" = "9",
}
/**
 * フェイクテーブルのリスト
 */

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "契約者番号",
    keyword: "contractorNo",
    type: "text",
  },
  {
    title: "契約者（法人）名",
    keyword: "contractorName",
    type: "nodeInLine",
  },
  {
    title: "契約者住所",
    keyword: "contractorAddress",
    type: "text",
  },
  {
    title: "TEL",
    keyword: "tel",
    type: "text",
  },
  {
    title: "FAX",
    keyword: "fax",
    type: "text",
  },
  {
    keyword: "lineTitle1",
    type: "lineTitle",
    lineTitle: "　",
  },
  {
    title: "施設番号",
    keyword: "facilityNo",
    type: "text",
  },
  {
    title: "施設名称",
    keyword: "facilityName",
    type: "nodeInLine",
  },
  {
    title: "施設住所",
    keyword: "facilityAddress",
    type: "text",
  },
  {
    title: "施設種類",
    keyword: "facilityType",
    type: "text",
  },
  {
    title: "施設区分",
    keyword: "facilityKbn",
    type: "text",
  },
  {
    keyword: "lineTitle2",
    type: "lineTitle",
    lineTitle: "　",
  },
  {
    title: "職員名",
    keyword: "staffName",
    type: "text",
  },
  {
    title: "性別",
    keyword: "gender",
    type: "text",
  },
  {
    title: "職種",
    keyword: "jobCd",
    type: "text",
  },
  {
    title: "生年月日",
    keyword: "birthday",
    type: "text",
  },
  {
    title: "加入日",
    keyword: "joinDate",
    type: "text",
  },
  {
    title: "被共済職員期間",
    keyword: "premiumEnroll",
    type: "text",
  },
  {
    title: "退職日",
    keyword: "retireDate",
    type: "text",
  },
  {
    title: "支給額",
    keyword: "paymentAmt",
    type: "text",
  },
  {
    title: "俸給表の額",
    keyword: "salaryTableAmt",
    type: "text",
  },
  {
    title: "俸給の調整額",
    keyword: "salaryAdjustmentAmt",
    type: "text",
  },
  {
    title: "合計",
    keyword: "totalPaymentAmt",
    type: "text",
  },
  {
    keyword: "lineTitle3",
    type: "lineTitle",
    lineTitle: "　",
  },
  {
    title: "被共済職員期間（職員情報訂正後）",
    keyword: "correctedMutualAidPeriod",
    type: "nodeInLine",
  },
  {
    title: "俸給表の額（職員情報訂正後）",
    keyword: "correctedSalaryTableAmt",
    disabled: true,
  },
  {
    title: "俸給の調整額（職員情報訂正後）",
    keyword: "correctedSalaryAdjustmentAmt",
    disabled: true,
  },
  {
    title: "合計（職員情報訂正後）",
    keyword: "correctedSum",
    disabled: true,
  },
  {
    title: "支給額（職員情報訂正後）",
    keyword: "correctedPaymentAmt",
    disabled: true,
  },
  {
    title: "追加支給額/返還額",
    keyword: "addCorrectedPaymentAmt",
    disabled: true,
  },
  {
    title: "追加支給/返還理由",
    keyword: "reason",
    type: "selectForm",
    selectPropsList: TkGetCodeList(AddPaymentReason),
    requiredIcon: true,
  },
  {
    title: "テーブル",
    keyword: "salaryTableList",
    type: "node",
  },
  {
    title: "ならない月",
    keyword: "unrecognizedMonthList",
    type: "node",
  },
  {
    title: "異動履歴",
    keyword: "transferHistoryList",
    type: "node",
  },
  {
    title: "テーブル",
    keyword: "childcareLeaveList",
    type: "node",
  },
  {
    title: "テーブル",
    keyword: "statusList",
    type: "node",
  },
  {
    title: "メモ",
    keyword: "memo",
    type: "node",
  },
];

const salaryTableHead = [
  {
    headTitle: "年月",
  },
  {
    headTitle: "俸給表の額",
  },
  {
    headTitle: "俸給の調整額",
  },
];

const ineligibleMonths: ITkFakeTableLineProps[] = [
  {
    title: "ならない月",
    keyword: "notToBeTable",
    type: "nodeInLine",
  },
];

const transferHistory: ITkFakeTableLineProps[] = [
  {
    title: "異動履歴",
    keyword: "transferHistoryList",
    type: "nodeInLine",
  },
];

const infoHeadTitleList = [
  {
    headTitle: "出生日",
  },
  {
    headTitle: "育児休業開始日",
  },
  {
    headTitle: "育児休業終了日",
  },
  {
    headTitle: "パパママ育休プラス",
  },

  {
    headTitle: "半年延長の理由",
  },
  {
    headTitle: "産後パパ育休",
  },
];

const headList = [
  {
    headTitle: "担当者",
  },
  {
    headTitle: "処理",
  },
  {
    headTitle: "実施日",
  },
  {
    headTitle: "コメント",
  },
];

const symbolHeadList: any[] = [
  {
    headTitle: "記号番号",
    align: "left",
  },
  {
    headTitle: "決裁日",
    align: "left",
  },
];

const schema: any = {
  memo: {
    maxLength: {
      value: 500,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "500"),
    },
  },
  selectForm: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  reason: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

const monthMapping = {
  apr: "4",
  may: "5",
  jun: "6",
  jul: "7",
  aug: "8",
  sep: "9",
  oct: "10",
  nov: "11",
  dec: "12",
  jan: "1",
  feb: "2",
  mar: "3",
} as any;

export {
  schema,
  fakeTableList,
  salaryTableHead,
  ineligibleMonths,
  transferHistory,
  infoHeadTitleList,
  headList,
  monthMapping,
  symbolHeadList,
};
